import { lazy } from 'react'

// Lazy auth page components, isolated here so authRoutes.jsx exports only its
// route-builder function (keeps react-refresh's only-export-components happy).
export const SignInPage = lazy(() => import('@/pages/Auth/SignIn'))
export const SignUpPage = lazy(() => import('@/pages/Auth/SignUp'))
export const ForgotPasswordPage = lazy(() => import('@/pages/Auth/ForgotPassword'))
export const ResetPasswordPage = lazy(() => import('@/pages/Auth/ResetPassword'))
